import { useEffect, useState } from 'react';
import { init, onFacebookShareClick } from 'src/utils/facebook';
import { onTwitterShareClick } from 'src/utils/twitter';
import SocialButton from 'src/components/buttons/socialButton';
import { isCategoryAccepted, Category } from 'src/utils/cookie';
const isServer = typeof window === 'undefined';
type Props = {
  name: string;
};
export default function SocialSharingButtons({
  name
}: Props) {
  const [encodedUrl, setEncodedUrl] = useState('');
  const [encodedSubject, setEncodedSubject] = useState('');
  useEffect(() => {
    setEncodedUrl(encodeURIComponent(`Hey! I thought you'd like this program on HealthUnlocked, ${name} - https://healthunlocked.com${window.location.pathname}`));
    setEncodedSubject(encodeURIComponent(name));
    if (isCategoryAccepted(Category.Functionality)) {
      init();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <div data-sentry-component="SocialSharingButtons" data-sentry-source-file="socialSharingButtons.tsx">
      {!isServer && isCategoryAccepted(Category.Functionality) && <SocialButton brand="facebook" hasBrandColor={false} onClick={() => onFacebookShareClick()} />}
      <SocialButton brand="twitter" hasBrandColor={false} onClick={() => onTwitterShareClick(name)} data-sentry-element="SocialButton" data-sentry-source-file="socialSharingButtons.tsx" />
      <a aria-label="mail" href={`mailto:?subject=${encodedSubject}&body=${encodedUrl}`} title="mail">
        <SocialButton brand="mail" data-sentry-element="SocialButton" data-sentry-source-file="socialSharingButtons.tsx" />
      </a>
    </div>;
}